export default {
  FETCH_TRANSLATIONS_SERVICE: {
    absoluteUrl: `https://api.${window.ENVIRONMENT}.wp.openbankpay.com/cf-api-translations/v2/internationalization/OP_LEN_ONB/translation/latest`,
    customHeaders: { bankId: 'CF_NL' },
  },
  STATIC_CALL_PARAMS: {
    customHeaders: { bankId: 'CF_NL' },
  },
};
